import { useMutation } from '@tanstack/react-query'
import { triggerHapticFeedback } from '@core/Utils/hapticFeedback/hapticFeedback'
import type { BetLoopSharedBet } from '@core/Areas/BetLoop/types'
import { handleApiErrorNotification } from '@core/Areas/BetLoop/helpers/handleApiErrorNotification'
import {
  postBetLoopFollowAccount,
  postBetLoopUnfollowAccount,
} from '@core/Areas/BetLoop/helpers/api'
import { trackBetLoopToggleFollow } from '@core/Areas/BetLoop/helpers/analytics'
import {
  patchFeedDataWithIsFollowingChange,
  patchPrincipalDataWithFollowingCount,
} from '../helpers/patchReactQueryData'

export const useFollowMutation = ({
  profileId,
  onFollowSuccess,
  isFollowingLocalState,
}: {
  isFollowingLocalState: boolean
  profileId: BetLoopSharedBet['ownerAccountId']
  onFollowSuccess(newState: boolean): void
}) => {
  const { mutate, isPending } = useMutation({
    mutationFn: () =>
      isFollowingLocalState
        ? postBetLoopUnfollowAccount(profileId)
        : postBetLoopFollowAccount(profileId),
    onSuccess: () => {
      const newIsFollowingState = !isFollowingLocalState
      triggerHapticFeedback('impact-light')
      onFollowSuccess(newIsFollowingState)
      patchFeedDataWithIsFollowingChange({ profileId, isFollowing: newIsFollowingState })
      patchPrincipalDataWithFollowingCount(newIsFollowingState)
      trackBetLoopToggleFollow(newIsFollowingState ? 'enable' : 'disable')
    },
    onError: e => handleApiErrorNotification(e),
  })

  return { mutate, isPending }
}
